import LinkingTool from "../../LinkingTool/LinkingToolComponents/LinkingTool";

const SoundRecordingLinkingTool = () => {
  return <LinkingTool />;
};

export default SoundRecordingLinkingTool;
